export function isAncestorElement(
  element: Element,
  maybeAncestor: Element,
): boolean {
  return (
    findParentElement(element, (el: Element) => el === maybeAncestor) !== null
  );
}

export function findParentElement<T extends Element>(
  element: Element,
  predicate: (el: Element) => el is T,
): T | null;

export function findParentElement(
  element: Element,
  predicate: (el: Element) => boolean,
): Element | null;

export function findParentElement(
  element: Element,
  predicate: (el: Element) => boolean,
): Element | null {
  let currentElement: Element | null = element;
  while (currentElement !== null) {
    if (predicate(currentElement)) {
      return currentElement;
    }
    currentElement = currentElement.parentElement;
  }
  return null;
}
